import React from "react";
import "./range-between.css";

const RangeBetweenField = ({
	field,
	value,
	onChange,
	error
}) => {
	const currentValue = value || {};
	const inputClassName = error ? "form-field__input--error" : "";

	const handleRangeChange = (rangeKey, rangeValue) => {
		const formatter = field.onChange || (currentRawValue => currentRawValue);

		onChange(field.name, {
			...currentValue,
			[rangeKey]: formatter(rangeValue)
		});
	};

	return (
		<div className="form-generic__range-between">
			<input
				id={field.fromId || `${field.name}From`}
				type={field.inputType || "text"}
				name={`${field.name}From`}
				className={inputClassName}
				aria-invalid={Boolean(error)}
				value={currentValue.from || ""}
				placeholder={field.fromPlaceholder}
				maxLength={field.maxLength}
				onChange={event => handleRangeChange("from", event.target.value)}
				disabled={field.disabled}
			/>

			<span>{field.separator || "até"}</span>

			<input
				id={field.toId || `${field.name}To`}
				type={field.inputType || "text"}
				name={`${field.name}To`}
				className={inputClassName}
				aria-invalid={Boolean(error)}
				value={currentValue.to || ""}
				placeholder={field.toPlaceholder}
				maxLength={field.maxLength}
				onChange={event => handleRangeChange("to", event.target.value)}
				disabled={field.disabled}
			/>
		</div>
	);
};

export default RangeBetweenField;